import Layout from 'antd/es/layout';
import { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import './styles.less';
import { checkAuth } from '@/apis';
import { observer } from 'mobx-react-lite';
import { EasyDrawContext } from '@/store';
import  UnifiedHeader from '@/components/Header';
import { Support } from '@/components/Support';
import { CenterSpin } from '@/components/Spin';

const prefixCls = 'ai-tools-wrapper'

export default observer(function AiToolsLayout() {

  const store = useContext(EasyDrawContext)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    checkAuth()
      .then(res => {
        const { data = {} } = res
        store.isLogin = !!data?.valid
        if (data?.valid) {
          store.userStore.queryUserInfo()
          store.notificationStore.init()
        }
      })
      .finally(() => setLoading(false))
  }, [])

  return (
    <Layout className={prefixCls}>
      <UnifiedHeader needSearch={false} className={`${prefixCls}-header`} />
      <CenterSpin spinning={loading} />
      {!loading && (
          <Outlet />
      )}
      <Support />
    </Layout>
  );
})
